import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectContextLocale } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { take } from 'rxjs/operators';

@Component({
  selector: 'am-banner-now-twelve',
  styleUrls: ['./banner-now-twelve.component.scss'],
  templateUrl: './banner-now-twelve.component.html',
})
export class BannerNowTwelveComponent implements OnInit {
  public imgNowTwelve: string;

  constructor(private store$: Store<IHotelsAppState>) {}

  public ngOnInit() {
    this.store$.pipe(select(selectContextLocale), take(1)).subscribe(() => {
      this.imgNowTwelve = `/hotels/results/dist/es-AR/assets/images/now-twelve-banner/now-12.png`;
    });
  }
}
